<template>
  <q-tabs
    :active-class="activeClass"
    :active-bg-color="activeBgColor"
    :content-class="computedContentClass"
    active-color="primary"
    no-caps
  >
    <slot></slot>
  </q-tabs>
</template>

<script setup>
const props = defineProps({
  indicator: {
    type: String,
    default: "line",
  },
  contentClass: {
    type: String,
    default: "overflow-unset q-gutter-lg",
  },
  hideArrows: {
    type: Boolean,
    default: true,
  },
});

const computedHideArrows = computed(() => (props.hideArrows ? "none" : "flex"));

const activeClass = computed(() => {
  return props.indicator === "line" ? "" : "elevation-1";
});

const activeBgColor = computed(() => {
  return props.indicator === "line" ? "" : "primary-30";
});

const computedContentClass = computed(() => {
  return props.indicator === "line" ? "overflow-auto" : props.contentClass;
});
</script>

<style lang="scss" scoped>
.q-tabs {
  &--dense {
    :deep(.q-tab) {
      min-height: 30px;
    }
  }
  :deep(.q-tabs__arrow) {
    color: $primary-100;
    display: v-bind(computedHideArrows);
  }
}
</style>
